import * as React from 'react'

import BeatIndicator from './graphics/BeatIndicator'
import Sketch from './Sketch'
import { KEY_POSITIONS } from './constants'
import SplashParticle from './graphics/SplashParticle'
import ParticleSystem from './graphics/ParticleSystem'

const getSketch = (width: number, height: number) => (p: any) => {
  let systems: ParticleSystem[] = []

  p.setup = () => {
    p.createCanvas(width, height)
  }

  p.draw = () => {
    p.background(0)
    systems.forEach(system => system.run())
  }

  p.keyTyped = () => {
    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      const x = p.constrain(p.random(position.x - 0.05, position.x + 0.05), 0, width)
      const y = p.constrain(p.random(position.y - 0.05, position.y + 0.05), 0, height)
      const beatSystem = new ParticleSystem(p, p.createVector(x * width, y * height), BeatIndicator)
      const splashSystem = new ParticleSystem(p, p.createVector(x * width, y * height), SplashParticle)
      splashSystem.addParticle(20)
      beatSystem.addParticle()
      systems.push(splashSystem)
      systems.push(beatSystem)
    }
  }

  p.superRemove = p.remove
  p.remove = () => {
    systems = []
    p.superRemove()
  }
}

const prompt = 'Type to the beat'

const Beat = () => <Sketch getSketch={getSketch} prompt={prompt} />

export default Beat



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Beat.tsx